import { List } from "@mui/material";
import SideMenuItem from "./SideMenuItem";

const SideMenu = (props) => <List disablePadding {...props} />;

SideMenu.Item = SideMenuItem;

export default SideMenu;
